// import "./app.css";
import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import {isRouteAFullURL, getStartingPath, getRoutes, getRecommendedRoute} from "./services/flow.service";

import LazyLoad from "./services/lazy.service";

const AsyncCoverageMap = LazyLoad(() => {
  return import("./pages/coverage-check/class");
});

const AsyncCoverageConfirm = LazyLoad(() => {
  return import("./pages/coverage-confirm/class");
});

const AsyncCoverageDetails = LazyLoad(() => {
  return import("./pages/coverage-details/class");
});

const AsyncAccount = LazyLoad(() => {
  return import("./pages/account/html");
});

const AsyncDelivery = LazyLoad(() => {
  return import("./pages/delivery/class");
});

const AsyncPayment = LazyLoad(() => {
  return import("./pages/payment/html");
});

const AsyncSubmitDelivery = LazyLoad(() => {
  return import("./pages/delivery/submit");
});

const AsyncThankYou = LazyLoad(() => {
  return import("./pages/thank-you/class");
});
const AsyncDeliveryClosed = LazyLoad(() => {
  return import("./pages/delivery/Delivery-closed");
});
const AsyncInstallments = LazyLoad(() => {
    if (window.innerWidth <= 640){
      return import("./pages/payment/IdUpload/Scan-or-upload")
    }else{
      return import("./pages/payment/IdUpload/IdUpload");
    }
});

const AsyncDeliveryType = LazyLoad(() => {
  return import("./pages/delivery/type");
});
const AsyncDeliveryAddress = LazyLoad(() => {
  return import("./pages/delivery/sim-delivery");
});
const AsyncReceiveInstalments = LazyLoad(() => {
  return import("./pages/payment/installments/ReceiveInstalment");
});
const AsynchUpsell = LazyLoad(() => {
	return import("./pages/planUpSell/PlanUpsell");
})
const ResidencyCheck = LazyLoad(() => {
	return import("./pages/residency/residency");
});
const AsyncPayOnline = LazyLoad(() => {
  return import('./pages/payOnline/payOnline');
});

const ui_map = {
  coverage_map: AsyncCoverageMap,
  coverage_confirm: AsyncCoverageConfirm,
  residency: ResidencyCheck,
  coverage_details: AsyncCoverageDetails,
  upsell: AsynchUpsell,
  account: AsyncAccount,
  pay_online : AsyncPayOnline,
  delivery: AsyncDelivery,
  delivery_type: AsyncDeliveryType,
  delivery_address :AsyncDeliveryAddress,
  payment: AsyncPayment,
  submit_delivery: AsyncSubmitDelivery,
  thank_you: AsyncThankYou,
};

export default function Main() {

  let main_routes = [];
  for (let route of Object.keys(ui_map)) {
    let flowRoutes = getRoutes();
    if (flowRoutes[route]) {
      main_routes.push(
        <Route
          path={flowRoutes[route]["path"]}
          exact
          key={flowRoutes[route]["path"] + Date.now()}
          component={ui_map[route]}
        />
      );
    }
  }

  return (
    <Switch>
      {main_routes}
      <Route
        path="/delivery-closed"
        exact
        key={"/delivery-closed" + Date.now()}
        component={AsyncDeliveryClosed}
      />
      <Route
        path="/installments"
        exact
        key={"/installments" + Date.now()}
        component={AsyncInstallments}
      />
      <Route
						path="/installment-fail"
						key={"/installment-fail" + Date.now()}
						exact
						component={AsyncReceiveInstalments}
			/>
      <Route
        path="/installment-success"
        key={"/installment-success" + Date.now()}
        exact
        component={AsyncReceiveInstalments}
      />
      <Route
        path="/"
        exact
        key={"/" + Date.now()}
        component={() => {
          let route = getRecommendedRoute("HomeRouter");
          if (!isRouteAFullURL(route)) {
            return <Redirect from="/" to={route} />;
          }
          return "";
        }}
      />
      <Redirect from="*" to={getStartingPath()} />
    </Switch>
  );
}
